var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "grid grid-cols-1 sm:grid-cols-2 gap-2 mt-2" },
    [
      _c(
        "span",
        {
          class: `inline-flex justify-center items-center px-2.5 py-1 rounded-md text-sm font-medium leading-5 ${_vm.colour} text-white transition-colors duration-300`,
        },
        [
          _c(
            "span",
            { staticClass: "block text-center" },
            [
              _vm.total > 2
                ? [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.total) +
                        " Seats Available\n            "
                    ),
                  ]
                : _vm.total > 0
                ? [
                    _vm._v(
                      "\n                Only " +
                        _vm._s(_vm.total) +
                        " " +
                        _vm._s(_vm.total !== 1 ? "Seats" : "Seat") +
                        " Left\n            "
                    ),
                  ]
                : [_vm._v("\n                Fully Booked\n            ")],
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass:
            "inline-flex justify-center items-center px-2.5 py-1 rounded-md text-sm font-medium leading-5 bg-gray-200 text-gray-800",
        },
        [
          _c("span", { staticClass: "block text-center" }, [
            _vm._v(
              _vm._s(_vm.member < 0 ? 0 : _vm.member) +
                " Member Seats Available"
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }